export const userPermissions = {
  USER_LIST: 'User.List',
  USER_READ: 'User.Read',
  USER_CREATE: 'User.Create',
  USER_UPDATE: 'User.Update',
  USER_DELETE: 'User.Delete'
} as const;

export const rolePermissions = {
  ROLE_LIST: 'Role.List',
  ROLE_READ: 'Role.Read',
  ROLE_CREATE: 'Role.Create',
  ROLE_UPDATE: 'Role.Update',
  ROLE_DELETE: 'Role.Delete'
} as const;

export const notificationPermissions = {
  NOTIFICATION_LIST: 'Notification.List',
  NOTIFICATION_READ: 'Notification.Read'
} as const;

export const projectPermissions = {
  PROJECT_LIST: 'Project.List',
  PROJECT_READ: 'Project.Read',
  PROJECT_CREATE: 'Project.Create',
  PROJECT_UPDATE: 'Project.Update',
  PROJECT_DELETE: 'Project.Delete'
} as const;

export const workerPermissions = {
  WORKER_LIST: 'Worker.List',
  WORKER_READ: 'Worker.Read',
  WORKER_CREATE: 'Worker.Create',
  WORKER_UPDATE: 'Worker.Update',
  WORKER_DELETE: 'Worker.Delete'
} as const;

export const timesheetPermissions = {
  TIMESHEET_LIST: 'Timesheet.List',
  TIMESHEET_READ: 'Timesheet.Read',
  TIMESHEET_SUBMIT: 'Timesheet.Submit',
  TIMESHEET_APPROVE: 'Timesheet.Approve'
} as const;

export const tigPermissions = {
  TIG_LIST: 'TIG.List',
  TIG_READ: 'TIG.Read',
  TIG_CREATE: 'TIG.Create'
} as const;

export const invoicePermissions = {
  INVOICE_LIST: 'Invoice.List',
  INVOICE_READ: 'Invoice.Read',
  INVOICE_UPLOAD: 'Invoice.Upload',
  INVOICE_MARK_PAID: 'Invoice.MarkPaid'
} as const;

export const kpiPermissions = {
  KPI_VIEW: 'KPI.View'
} as const;

export const rateHistoryPermissions = {
  RATE_HISTORY_MANAGE: 'RateHistory.Manage'
} as const;

export const talentPoolPermissions = {
  TALENT_POOL_LIST: 'TalentPool.List',
  TALENT_POOL_READ: 'TalentPool.Read',
  TALENT_POOL_CREATE: 'TalentPool.Create',
  TALENT_POOL_UPDATE: 'TalentPool.Update',
  TALENT_POOL_DELETE: 'TalentPool.Delete'
} as const;

export const permissions = {
  user: userPermissions,
  role: rolePermissions,
  notification: notificationPermissions,
  project: projectPermissions,
  worker: workerPermissions,
  timesheet: timesheetPermissions,
  tig: tigPermissions,
  invoice: invoicePermissions,
  kpi: kpiPermissions,
  rateHistory: rateHistoryPermissions,
  talentPool: talentPoolPermissions
} as const;

export const permissionCodeMap: Record<number, string> = {
  2000: userPermissions.USER_LIST,
  2001: userPermissions.USER_READ,
  2002: userPermissions.USER_CREATE,
  2003: userPermissions.USER_UPDATE,
  2004: userPermissions.USER_DELETE,
  3000: rolePermissions.ROLE_LIST,
  3001: rolePermissions.ROLE_READ,
  3002: rolePermissions.ROLE_CREATE,
  3003: rolePermissions.ROLE_UPDATE,
  3004: rolePermissions.ROLE_DELETE,
  4000: 'Permission.List',
  5000: notificationPermissions.NOTIFICATION_LIST,
  5001: notificationPermissions.NOTIFICATION_READ,
  6000: projectPermissions.PROJECT_LIST,
  6001: projectPermissions.PROJECT_READ,
  6002: projectPermissions.PROJECT_CREATE,
  6003: projectPermissions.PROJECT_UPDATE,
  6004: projectPermissions.PROJECT_DELETE,
  6100: workerPermissions.WORKER_LIST,
  6101: workerPermissions.WORKER_READ,
  6102: workerPermissions.WORKER_CREATE,
  6103: workerPermissions.WORKER_UPDATE,
  6104: workerPermissions.WORKER_DELETE,
  6200: timesheetPermissions.TIMESHEET_LIST,
  6201: timesheetPermissions.TIMESHEET_READ,
  6202: timesheetPermissions.TIMESHEET_SUBMIT,
  6203: timesheetPermissions.TIMESHEET_APPROVE,
  6300: tigPermissions.TIG_LIST,
  6301: tigPermissions.TIG_READ,
  6302: tigPermissions.TIG_CREATE,
  6400: invoicePermissions.INVOICE_LIST,
  6401: invoicePermissions.INVOICE_READ,
  6402: invoicePermissions.INVOICE_UPLOAD,
  6403: invoicePermissions.INVOICE_MARK_PAID,
  6500: kpiPermissions.KPI_VIEW,
  6600: rateHistoryPermissions.RATE_HISTORY_MANAGE,
  6700: talentPoolPermissions.TALENT_POOL_LIST,
  6701: talentPoolPermissions.TALENT_POOL_READ,
  6702: talentPoolPermissions.TALENT_POOL_CREATE,
  6703: talentPoolPermissions.TALENT_POOL_UPDATE,
  6704: talentPoolPermissions.TALENT_POOL_DELETE
};
